import { SummaryCell } from "./summaryCell";

export class EmptyCell extends SummaryCell {
    constructor() {
        super(null);
    }

    protected genHtml(): string {
        return "";
    }
}
